import React from 'react';
import AccountCircleTwoToneIcon from '@material-ui/icons/AccountCircleTwoTone';
import { makeStyles } from '@material-ui/core/styles';
import { storeContext } from '../provider/Provider';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    padding: 2,
    '& > *': {
      margin: theme.spacing(1),
    },
    marginTop: 15,
  },
  name: {
    fontSize: 21,
    marginLeft: 6,
  },
  email: {
    fontSize: 19,
    color: '#90A0B7',
  },
  avatar: {
    marginTop: 'auto',
    marginBottom: 'auto',
    width: 40,
    height: 40,
    fill: theme.palette.primary.lighter,
  },
}));

const UserLabel = () => {
  const { state } = React.useContext(storeContext);
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AccountCircleTwoToneIcon className={classes.avatar} />
      <div>
        <span className={classes.name} data-testid="user_label_test_id">
          {state.auth.user.name}
        </span>
      </div>
    </div>
  );
};

export default UserLabel;
